<template>
  <v-tabs
    v-model="currentTab"
    centered
    color="transparent"
    light
    fixed-tabs
  >
    <v-tabs-slider color="#0099E1"></v-tabs-slider>
    <v-tab
      v-for="tab in tabs"
      :href="'#tab-' + tab.name"
      :key="tab.name"
      :id="tab.name"
      :disabled="tab.isDisabled"
    >
      {{tab.tabName}}
    </v-tab>

    <v-tabs-items touchless v-model="currentTab">
      <v-tab-item
        v-for="tab in tabs"
        :value="'tab-' + tab.name"
        :key="tab.name"
      >
        <v-card color="transparent" flat>
            <component :is="tab.component" ref="childComponent" :devices="devices"></component>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>

import DevicesList from './DevicesList.vue';
import DevicesMap from './DevicesMap.vue';
import { USER_QUERY } from '../../constants/graphql';

export default {
  name: 'equipments',
  components: {
    DevicesList,
    DevicesMap
  },
  data () {
    return {
      User: {
        Organization: {
          Device: []
        }
      },
      currentTab: 'tab-devices-list',
      tabs: [
        {
          name: 'devices-list',
          tabName: 'Lista',
          component: 'DevicesList',
          isDisabled: false
        },
        {
          name: 'devices-map',
          tabName: 'Mapa',
          component: 'DevicesMap',
          isDisabled: true
        }
      ]
    };
  },
  apollo: {
    User: {
      query: USER_QUERY,
      variables () {
        return {
          id: this.$store.getters.user.id
        };
      }
    }
  },
  computed: {
    devices () {
      if (this.User.Organization) {
        let deviceList = [];
        const organizationList = this.User.Organization;
        if (organizationList.length) {
          organizationList.forEach(org => {
            const auxDevices = org.Device;
            if (auxDevices.length) {
              auxDevices.forEach((device, index) => {
                auxDevices[index].orgName = org.name;
              });
            }
            deviceList = deviceList.concat(auxDevices);
          });
        };
        return deviceList;
      } else {
        return [];
      }
    }
  },
  methods: {},
  created () {
    mixpanel.identify(this.User.id);
    mixpanel.people.set({
      '$email': this.User.email,
      '$name': this.User.name
    });
    gtag('set', 'user_properties', {
      name: this.User.name
    });
    mixpanel.track('/equipments');
    gtag('config', 'GA_MEASUREMENT_ID', {
      'page_title': 'Equipments',
      'page_path': '/equipments'
    });
  }
};
</script>


// WEBPACK FOOTER //
// Equipments.vue?2bd2ad4e